"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const _4d_mapper_1 = require("4d-mapper");
class ProjectTipsDialogComponent {
    constructor(dialogRef, data, fourD) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.showProjectTips = false;
    }
    ngOnInit() {
        if (this.fourD.activeTeam.hasOwnProperty('showProjectTips')) {
            this.showProjectTips = !this.fourD.activeTeam['showProjectTips'];
        }
    }
    onClick() {
        this.fourD.activeTeam['showProjectTips'] = !this.showProjectTips;
        this.fourD.activeTeam.saveObservable().subscribe();
        this.dialogRef.close(true);
    }
}
exports.ProjectTipsDialogComponent = ProjectTipsDialogComponent;
